import { isString } from 'utils/helpers';
import { FieldType } from 'modules/queryBuilder/types';
import { isCampaignLabelIdCondition } from '../isCampaignLabelIdCondition';

export const transformCampaignLabelCondition = <Condition extends Record<string, unknown>>(
  condition: Condition,
) =>
  isString(condition.field) && isCampaignLabelIdCondition(condition.field)
    ? { ...condition, fieldType: FieldType.CAMPAIGN_LABEL_ID }
    : condition;
